// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-Heading-module--cls1--3y07_","cls2":"index-Heading-module--cls2--2RiAJ index-Heading-module--cls1--3y07_"};